import {
    Notification
} from 'element-ui';

const state = {
    client: null,
    form: {
        first_name: '',
        last_name: '',
        phone: '',
        email: '',

        password: '',
        newPassword: ''
    }
}

const mutations = {
    setState: (state, {
        key,
        value
    }) => {
        state[key] = value;
    },
    setClientForm: (state, v) => {
        state.form.first_name = v.first_name;
        state.form.last_name = v.last_name;
        state.form.phone = v.phone;
        state.form.email = v.email;
    }
}

const actions = {
    async fetch({
        commit
    }) {
        const response = await this.$api.client.self();

        commit('setState', {
            key: 'client',
            value: response.data
        });
    },

    async save({
        commit
    }, form) {
        const response = await this.$api.client.save(form);
        return response;
    },

    async deleteAccount({
        commit
    }) {
        const response = await this.$api.client.deleteAccount();

        if (response.status == 204) {
            this.$api.auth.$axios.clearCookies();
            this.router.push({
                path: '/auth/login'
            });
        } else if (response.status == 409) {
            Notification({
                title: 'Error 409',
                message: response.data.message,
                duration: 1300
            });
        }
    },

    async saveImage({
        commit
    }, form) {
        return await this.$api.client.uploadImage(form);
    },

    async checkCoordinates({
        state
    }, id) {
        return await this.$api.client.checkCoordinates(id);
    }
}

const getters = {
    client: state => state.client,
    form: state => state.form
}

export default {
    namespaced: true,

    state,
    mutations,
    actions,
    getters
}